import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { locationQuerySchema } from './location-query-schema';

export const locationFormSchema = locationQuerySchema.omit({ name: true, status: true }).extend({
  name: z.string().min(3),
  status: statusFormSchema,
});
export type LocationFormSchema = z.infer<typeof locationFormSchema>;
